import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcelInventory, downloadInventoryInwardPdf, getInventoryInwards } from '@/api/inventory-inwards';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { getUnits } from '@/api/locations/units';
import { getAdmins } from '@/api/admins';
import { searchProducts } from '@/api/products';
import InventoryRemove from './components/InventoryRemove.vue';
import { isAdmin, isSuperAdmin, isUnitManager } from '@/common';
import { BranchAgentService } from '@/services/branch-agent-service';
import Inr from '@/components/Inr/index.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.productIdRowsCount = {};
    this.listLoading = false;
    this.downloadLoading = false;
    this.productList = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.dialogVisible = false;
    this.inventoryInwardId = 0;
    this.inventoryInwardData = null;
    this.stockQuery = {};
    this.listQuery = {
      page: 1,
      limit: 20,
      unitId: undefined,
      adminId: undefined,
      productId: undefined
    };
    this.loggedInAdmin = null;
    this.unitManagers = [];
    this.unitList = [];
    this.assignedBranches = [] || null;
    this.isZonalManager = false;
    this.fromMumbaiBranch = false;
  }
  async activated() {
    this.loggedInAdmin = AdminModule;
    if (this.loggedInAdmin.branchIds.includes(1)) {
      this.fromMumbaiBranch = true;
    }
    if (AdminModule.roles[0] === 'Zonal Manager') {
      this.isZonalManager = true;
    }
    this.$nextTick(() => {
      // get unit managers
      this.fetchUnitManagers();
    });
    // Assign branchId using BranchAgentService
    this.assignedBranches = await BranchAgentService.assignBranchId();
    // Check if branchId is null and throw an error
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    // get all inventory
    // this.getList();
  }
  async handleClearBranch() {
    // Assign branchId using BranchAgentService
    this.listQuery.branchId = await BranchAgentService.assignBranchId();
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.listQuery.branchId);
  }
  async fetchUnitManagers() {
    let managerUnitId;
    // if adding & logged in user is unit manager
    // if (this.loggedInAdmin.adminsRoleId === 3) {
    if (isUnitManager()) {
      managerUnitId = this.loggedInAdmin.id;
      // set to form data
      this.listQuery.adminId = this.loggedInAdmin.id;
      // fetch units as per manager
      this.fetchUnitList();
    }
    const result = await getAdmins(getQuery({
      id: managerUnitId,
      enabled: true,
      adminsRoleId: 2,
      filter: {
        id: '$eq',
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.unitManagers = result.data;
  }
  async fetchUnitList() {
    try {
      // empty check adminId
      if (!this.listQuery.adminId) {
        // unset unit ID
        this.listQuery.unitId = undefined;
        // empty unit list
        this.unitList = [];
        // empty inventory list
        this.list = [];
      } else {
        this.unitList = await getUnits(getQuery({
          enable: true,
          'admin.id': this.listQuery.adminId,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq',
            'admin.id': '$eq'
          },
          select: ['id', 'name', 'code'].join(',')
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getList() {
    try {
      this.listLoading = true;
      // get data
      if (typeof this.listQuery.unitId === 'number') {
        const data = await getInventoryInwards(this.listQuery);
        const inventoryInwards = data.data;
        // order by product id
        inventoryInwards.sort((a, b) => a.product_id - b.product_id);
        /* find out product id rows count & assign to find product id row */
        this.productIdRowsCount = {};
        inventoryInwards.forEach(item => {
          if (this.productIdRowsCount[item.product_id]) {
            this.productIdRowsCount[item.product_id] += 1;
          } else {
            this.productIdRowsCount[item.product_id] = 1;
          }
        });
        // set to list
        this.list = data.data;
        this.total = data.total;
        this.listLoading = false;
      } else {
        this.list = [];
        this.total = 0;
        this.listLoading = false;
      }
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchProductList(query) {
    try {
      if (query.length > 2) {
        this.productList = await searchProducts(getQuery({
          keyword: query
        }));
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async handleFilter() {
    var _AdminModule$branchId;
    this.listQuery.page = 1;
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  toggleDialog(data = null) {
    // First close and reset
    this.dialogVisible = false;
    this.inventoryInwardId = 0;
    this.inventoryInwardData = null;
    // Use nextTick to ensure Vue re-renders with cleared state before setting new data
    this.$nextTick(() => {
      this.inventoryInwardData = data;
      this.inventoryInwardId = data.id;
      this.dialogVisible = true;
    });
  }
  handleDialog(showDialog) {
    this.dialogVisible = !showDialog;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
  doProductRowSpan(args) {
    const {
      row,
      column,
      rowIndex,
      columnIndex
    } = args;
    if (columnIndex === 0) {
      if (rowIndex > 0) {
        const prevRow = this.list[rowIndex - 1];
        if (prevRow.product_id === row.product_id) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      return {
        rowspan: this.productIdRowsCount[row.product_id],
        colspan: 1
      };
    }
    return 0;
  }
  async downloadData() {
    this.listLoading = true;
    try {
      const params = {};
      if (this.listQuery.unitId) {
        params.unitId = this.listQuery.unitId;
      }
      if (this.listQuery.productId) {
        params.productId = this.listQuery.productId;
      }
      if (Object.keys(params).length) {
        const data = await downloadInventoryInwardPdf(getQuery(params));
        window.open(data.url, '_blank');
      } else {
        this.$message({
          message: 'Please select atleast one filter',
          type: 'warning'
        });
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const blob = await downloadExcelInventory(this.listQuery);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'inventory-stock.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  getSummaries(param) {
    const {
      columns
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      if (column.label === 'Stock Value') {
        const total = this.list.reduce((acc, row) => {
          return acc + (Number(row.stockValue) || 0);
        }, 0);
        // Format as INR — mirrors your <inr> component display
        sums[index] = `₹ ${total.toLocaleString('en-IN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`;
      } else {
        sums[index] = '';
      }
    });
    return sums;
  }
};
default_1 = __decorate([Component({
  name: 'InventoryInwardList',
  components: {
    Pagination,
    Enabled,
    InventoryRemove,
    Inr
  }
})], default_1);
export default default_1;